<template>
  <div class="TimeTag">
    <mu-col span="12" class="TimeRow">
      <mu-row gutter>
        <mu-col v-for="(item, index) in TimeList" :key="index" span="6" class="TimeContainer" @click="TagSel(index, item)">
          <mu-paper :z-depth="5" :style="item.IsBooked? BookedPaper : (item.IsCanSel? NormalPaper : DisPaper)" class="Paper">
            <label>{{ item.StartTime }}-{{ item.EndTime }}</label>
            <div>
              <label>{{ item.CompName }}</label>
            </div>
            <div v-show="item.IsBooked && item.IsAudit === 0" class="WaitVerify">待审核</div>
          </mu-paper>
          <div v-show="item.IsBooked" class="BookedTag"/>
          <div v-show="item.IsBooked" class="BookedText">已约</div>

          <div v-show="!item.IsBooked && item.IsSel === 1" class="SelTag"/>
          <div v-show="!item.IsBooked && item.IsSel === 1" class="SelText">
            <mu-icon value="check" color="#ffffff" size="10"/>
          </div>
        </mu-col>
      </mu-row>
    </mu-col>
  </div>
</template>

<script>
import Toast from 'muse-ui-toast'
export default {
  name: 'TimeTag',
  props: {
    TimeList: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      BookedPaper: {
        color: '#ffffff',
        'background-color': '#673ab7'
      },
      NormalPaper: {
        color: '#000000',
        'background-color': '#ffffff'
      },
      DisPaper: {
        color: '#e1e1e1',
        'background-color': '#ffffff'
      }
    }
  },
  methods: {
    TagSel: function(index, SelItem) {
      // if (!this.$store.getters.token && !this.$store.getters.wxtoken) {
      //   Toast.info('请先登录')
      //   this.$router.push({ name: 'Login' })
      //   return
      // }
      if (SelItem.IsBooked) {
        if (this.$store.getters.token) {
          this.$emit('SelInfo', SelItem)
        } else {
          if (!this.$store.getters.wxtoken) {
            Toast.info('请先登录')
            this.$router.push({ name: 'Login' })
          } else {
            this.$emit('CanselBook', SelItem)
          }
        }
      } else {
        // 可选择逻辑
        if (!this.$store.getters.wxtoken) {
          Toast.info('请先登录')
          this.$router.push({ name: 'Login' })
        }
        if (SelItem.IsCanSel) {
          if (SelItem.IsSel === 0) {
            SelItem.IsSel = 1
            this.$emit('AddSelItem', { index, SelItem })
          } else if (SelItem.IsSel === 1) {
            SelItem.IsSel = 0
            this.$emit('RemSelItem', { index, SelItem })
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.TimeTag{
  width: 100%;
}
.TimeRow{
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.TimeContainer{
  margin-bottom: 10px;
}
.Paper{
  width: 100%;
  height: 50px;
  padding: 5px 10px;
}
.BookedTag{
  position: absolute;
  top: 0px;
  right: 8px;
  width: 25px;
  height: 25px;
  border-right: 25px solid #dd2c00;
  border-bottom: 25px solid transparent;
  font-size: 10px;
}
.BookedText{
  position:absolute;
  top: 5px;
  right: 10px;
  font-size: 6px;
  color: #ffffff;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  transform: rotate(45deg);
}
.SelTag{
  position: absolute;
  top: 0px;
  right: 8px;
  width: 25px;
  height: 25px;
  border-right: 25px solid #673ab7;
  border-bottom: 25px solid transparent;
  font-size: 10px;
}
.SelText{
  position:absolute;
  top: 5px;
  right: 10px;
  font-size: 6px;
  color: #ffffff;
  /* -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  transform: rotate(45deg); */
}

.WaitVerify{
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.8);
  height: 50px;
  width: calc(100% - 16px);
  line-height: 50px;
  position: absolute;
  top: 0px;
  left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/view/BookPage/components/TimeTag.vue